export { default } from "./RetailerDetailsCard";
